import * as React from 'react';
import styled from 'styled-components';
import { rem} from 'polished';
import { __ } from 'react-i18n';
import { TagType, DsiTag as Tag } from '../Product/Tag';
import { DsiSvgIcon as SvgIcon, IconType } from '../General/SvgIcon';
import { getProductDefaultInfo } from '../../../utilities/selectors';

interface Props {
  product: any;
}

function ProductTabGiftLabel({ product }: Props) {
    const picture = product.picture
    ? `${process.env.REACT_APP_API_IMAGE_URL ||
        process.env
          .REACT_APP_API_BASE_URL}/image?query=${product.picture}&width=50&height=50&webp=0`
    : '/images/icons/placeholder.svg';
  
    return (
      <>
        <Wrapper>
            <SvgIcon
                icon={IconType.gift}
                width={50}
                height={50}
                fill="orange"
                title={__('Darček ku produktu')}
                viewBox="0 0 26 26"
            />
            <ProductNameText>
                {__("Darček")}: {product.name}
            </ProductNameText>
            <ProductImage src={picture}/>
        </Wrapper>
      </>
    );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* background-color: #ffe3b4; */
  border: 2px solid orange;
  padding-left: ${rem(10)};
  padding-right: ${rem(10)};
  padding-top: ${rem(10)};
  padding-bottom: ${rem(10)};
  width: 100%;
  gap: ${rem(10)};
  align-items: center;
`;

const ProductNameText = styled.div`
  color: orange;  
  font-weight: 500;
`

const ProductImage = styled.img`
  
`

export { ProductTabGiftLabel };
